import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzOffer180 } from './pages'

type TIdToPageMapWoofzOffer180 = Record<PageIdWoofzOffer180, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_OFFER1_80: TIdToPageMapWoofzOffer180 = {
  [PageIdWoofzOffer180.SUBSCRIPTIONS_OFFER1_80]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_offer/woofz_offer1_80/pages/subscriptions/SubscriptionsOffer180'
      ).then((m) => ({
        default: m.SubscriptionsOffer180,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_offer/woofz_offer1_80/pages/subscriptions/SubscriptionsOffer180'
      ),
  },
  [PageIdWoofzOffer180.CHAT_UPSELL_OFFER1_80]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_offer/woofz_offer1_80/pages/upsell/ChatUpsellNewFlow'
      ).then((m) => ({
        default: m.ChatUpsellNewFlow,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_offer/woofz_offer1_80/pages/upsell/ChatUpsellNewFlow'
      ),
  },
  [PageIdWoofzOffer180.UPSELL_OFFER1_80]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_offer/woofz_offer1_80/pages/upsell/Upsell'
      ).then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_offer/woofz_offer1_80/pages/upsell/Upsell'),
  },
  [PageIdWoofzOffer180.DOWNLOAD_OFFER1_80]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_offer/woofz_offer1_80/pages/download-app/DownloadApp'
      ).then((m) => ({
        default: m.DownloadApp,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_offer/woofz_offer1_80/pages/download-app/DownloadApp'
      ),
  },
  [PageIdWoofzOffer180.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
